var $fd4e8fdfbca066c7$exports = {};
$fd4e8fdfbca066c7$exports = {
    "replaceMessage": `\u{D30C}\u{C77C}\u{C744} \u{B4DC}\u{B86D}\u{D558}\u{C5EC} \u{BC14}\u{AFB8}\u{AE30}`
};


export {$fd4e8fdfbca066c7$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
